export default __webpack_public_path__ + "static/media/9c-2x.309845b0.png";